import './plugins/prototype';

import Vue from 'vue'
import axios from 'axios'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify'
import vueDayjs from "./plugins/vue-dayjs";
import vueMeta from 'vue-meta';
import vueCookies from 'vue-cookies';
import './plugins/vue-homecc';

import App from './AppMain.vue'

// SVG ICONS
import iconBase from '@/components/plugins/svg/icon-base.vue';
import binRounded from '@/components/plugins/svg/icons/bin-rounded.vue';
import closeRounded from '@/components/plugins/svg/icons/close-rounded.vue';
Vue.component("icon-base", iconBase);
Vue.component("bin-rounded", binRounded);
Vue.component("close-rounded", closeRounded);

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.use(vueDayjs);
Vue.use(vueCookies);
Vue.use(vueMeta, {
    // optional pluginOptions
    attribute: undefined,
    refreshOnceOnNavigation: true
})


if (process.env.NODE_ENV == "production" && location.protocol != "https:") location.protocol = "https:";

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')